import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getEvent } from "../services/apiEvents.js";
import EventBox from "../events/EventBox.jsx";
import Spinner from "../ui/Spinner.jsx";
import NotFound from "./NotFound.jsx";

export default function EventDetails() {
    const { eventId } = useParams();
    const { data: event, isLoading, error, refetch } = useQuery({
        queryKey: ["events", "detail", eventId],
        queryFn: () => getEvent(eventId),
        retry: false,
    });
    if (isLoading) return <Spinner />;
    if (error) return <main className="p-8"><p role="alert">{error.message}</p><button onClick={() => refetch()}>Try again</button></main>;
    if (!event) return <NotFound title="Event not found" />;
    return <main className="mx-auto max-w-3xl p-4">
        <Link to="/">Back to the party calendar</Link>
        <h1 className="text-2xl font-bold my-4">{event.name}</h1>
        <EventBox key={event.id} event={event} />
    </main>;
}
